import React, { FC, useState, useRef } from 'react';
import styles from './SortFilter.module.scss';
import { useClickOutside } from 'hooks/useOnClickOutside';
import { ReactComponent as IconCloseBlue } from '../img/filters/iconCloseBlue.svg';
import { ReactComponent as IconSort } from '../img/filters/iconSort.svg';
import { ReactComponent as IconSignedCustomer } from '../img/filters/iconSignedCustomer.svg';
import { ReactComponent as IconDateEnd } from '../img/filters/iconDateEnd.svg';
import { ReactComponent as IconDateStart } from '../img/filters/iconDateStart.svg';
import { ReactComponent as IconEmployed } from '../img/filters/iconEmployed.svg';
import { ReactComponent as IconSignedEmployed } from '../img/filters/iconSignedEmployed.svg';
import { TextWithTooltip } from 'hooks/TextWithTooltip';
import { ChildrenType } from 'redux/Api/contractsApi/type';

interface PropsType {
  active?: string;
  lists: ChildrenType[];
  setActive: (tab: string) => void;
  localStorageKey?: string;
  isLoading?: boolean;
}

export const SortFilter: FC<PropsType> = ({
  active,
  lists,
  setActive,
  localStorageKey = 'employedsSort_type',
  isLoading = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const clickOutsideRef = useClickOutside(() => setIsOpen(false));
  const contentRef = useRef<HTMLDivElement>(null);
  const name = lists?.find((item) => item.keyword === active)?.title;

  const handleClearSort = () => {
    if (isLoading) return;
    localStorage.setItem(localStorageKey, 'default');
    setActive('default');
    setIsOpen(false);
  };

  const getSortIcon = (keyword: string) => {
    switch (keyword) {
      case 'date_start':
        return <IconDateStart />;
      case 'date_end':
        return <IconDateEnd />;
      case 'customer_signed_at':
        return <IconSignedCustomer />;
      case 'worker_signed_at':
        return <IconSignedEmployed />;
      case 'worker_fio':
      case 'last_name_desc':
        return <IconEmployed />;
      default:
        return null;
    }
  };

  const Menu = () => {
    return (
      <ul className={styles.list} ref={clickOutsideRef}>
        {lists?.map((item, i) => (
          <li
            className={`${styles.item} ${
              item.keyword === active ? styles.item_active : ''
            }`}
            onClick={() => {
              localStorage.setItem(localStorageKey, item.keyword);
              setActive(item.keyword);
              setIsOpen(false);
            }}
            key={i}>
            {getSortIcon(item.keyword)}
            {item.title}
          </li>
        ))}
      </ul>
    );
  };

  return (
    <div className={styles.root}>
      <div
        ref={contentRef}
        className={`${styles.content} ${active !== 'default' ? styles.active : ''}`}
        onClick={() => setIsOpen((prev) => !prev)}>
        <div className={styles.contentInner}>
          {active === 'default' && <IconSort className={styles.icon} />}
          <div
            className={`${styles.name} ${
              active !== 'default' ? styles.name_active : ''
            }`}>
            {name ? (
              <TextWithTooltip content={name} className={styles.nameText} />
            ) : (
              <span className={styles.nameText}>Сортировка</span>
            )}
          </div>
          {active !== 'default' && (
            <IconCloseBlue
              className={styles.icon}
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                e.preventDefault();
                handleClearSort();
              }}
            />
          )}
        </div>
      </div>
      {isOpen && <Menu />}
    </div>
  );
};
